// @flow
import type { Element } from 'react';

import React from 'react';
import { FEMA_154_SCORE_CALCULATION_METHODS } from '@hbrisk/sp3-risk-model-support/models/fema154ScoreCalculationMethods.js';
import SelectMenu from '#components/pages/Models/Model/sections/support/forms/SelectMenu/index.js';

type Props = {|
  form: string,
  name: string,
|};

const FEMA154ScoreCalculationMethodSelectMenu = ({
  form,
  name,
}: Props): Element<typeof SelectMenu> => (
  <SelectMenu
    form={form}
    items={FEMA_154_SCORE_CALCULATION_METHODS}
    id={name}
    name={name}
    inputClassName="fema-154-score-calculation-method-select-menu"
  />
);

export default FEMA154ScoreCalculationMethodSelectMenu;
